/**
 * Dev-only loader for agentation-svelte, the feedback toolbar.
 *
 * The same optional git dependency the platform repo's clients use
 * (`platform/clients/shared-assets/lib/devtools/agentation.svelte.ts` explains
 * the pin and its install traps). To pick up a change, move the sha in
 * package.json and run `pnpm install`, then check that
 * node_modules/agentation-svelte/dist exists — a failed build installs as a
 * broken symlink with no dist/. Either way the toolbar is absent, not an error:
 * `agentationFallback` in vite.config.ts serves an empty stub in its place.
 *
 * Mount `DevToolbar.svelte` (beside this file) once, in the root layout.
 */

/// <reference path="./agentation.d.ts" />

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AgentationExports = Record<string, any>;

let mod = $state<AgentationExports | null>(null);
let attempted = false;

function ensureLoaded() {
	if (attempted) return;
	attempted = true;

	if (!import.meta.env.DEV) return;

	import('agentation-svelte')
		.then((m) => {
			mod = m;
		})
		.catch(() => {});
}

export function getAgentation(): AgentationExports | null {
	ensureLoaded();
	return mod;
}
